export { default } from './CountdownTimer';



// WEBPACK FOOTER //
// ./src/client/js/view/components/CountdownTimer/index.js